import { appI18n } from './i18n';

// Original: '因涉嫌违反平台分享政策，无法查看'
export const getIllegalText = () => appI18n.t('common.illegal_text') as string;
export const ILLEGAL_TEXT = getIllegalText(); // deprecated, use getIllegalText()

// Original: '未命名用户'
export const getUnnamedUser = () => appI18n.t('common.unnamed_user') as string;
export const UNNAMED_USER = getUnnamedUser(); // deprecated, use getUnnamedUser()
